import { render, staticRenderFns } from "./FavoriteItem.vue?vue&type=template&id=15ff1c9f&"
import script from "./FavoriteItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports